import {Component, effect, inject, signal, WritableSignal} from '@angular/core';
import {ITenant, UserService} from 'frontier';
import {AppService} from '../../../api/generated';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {LetterOfResignationService} from './letter-of-resignation.service';

@Component({
  selector: 'app-letter-of-resignation',
  standalone: true,
  imports: [],
  templateUrl: './letter-of-resignation.component.html',
  styleUrl: './letter-of-resignation.component.scss'
})
export class LetterOfResignationComponent {
  href: string;
  private _userService: UserService = inject(UserService);
  private _appService: AppService = inject(AppService);
  private _sanitizer: DomSanitizer = inject(DomSanitizer);
  private _letterOfResignationService = inject(LetterOfResignationService);

  sanitizedUrl: WritableSignal<SafeResourceUrl> = signal<SafeResourceUrl>(null);
  error: WritableSignal<string> = signal<string>(null);
  currentTenant: WritableSignal<string> = signal<string>(null);

  constructor() {
    this._userService.userGetGetTenantInfos().subscribe((r: object): void => {
      const res = r as {
        default: string,
        current: string,
        tenants: ITenant[],
      };
      this.currentTenant.set(res.current);
    });

    effect(() => {
      const url = this._letterOfResignationService.url()
      const currentTenant = this.currentTenant();

      if (!currentTenant) {
        return
      }

      if (!url) {
        this._appService.servicesGetrevisor().subscribe((link: string): void => {
          this._letterOfResignationService.url.set(link)
        });
      }
      else {
        this.href = url;
        this.sanitizedUrl.set(this._sanitizer.bypassSecurityTrustResourceUrl(this.href));
      }
    }, {allowSignalWrites: true});
  }
}
